/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PaymentCorpoCardSetupMutationVariables = {|
  corpoRef: string
|};
export type PaymentCorpoCardSetupMutationResponse = {|
  +payment: ?{|
    +corpo: ?{|
      +res: ?{|
        +code: number,
        +message: string,
        +data: ?any,
      |}
    |}
  |}
|};
export type PaymentCorpoCardSetupMutation = {|
  variables: PaymentCorpoCardSetupMutationVariables,
  response: PaymentCorpoCardSetupMutationResponse,
|};
*/


/*
mutation PaymentCorpoCardSetupMutation(
  $corpoRef: String!
) {
  payment {
    corpo {
      res: createCardSetupIntent(corpoRef: $corpoRef) {
        code
        message
        data
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "corpoRef"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PaymentMutation",
    "kind": "LinkedField",
    "name": "payment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PaymentCorpoMutation",
        "kind": "LinkedField",
        "name": "corpo",
        "plural": false,
        "selections": [
          {
            "alias": "res",
            "args": [
              {
                "kind": "Variable",
                "name": "corpoRef",
                "variableName": "corpoRef"
              }
            ],
            "concreteType": "PaymentPaymentPayload",
            "kind": "LinkedField",
            "name": "createCardSetupIntent",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "data",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PaymentCorpoCardSetupMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PaymentCorpoCardSetupMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f6102d3b1a058cb449684862c499f442",
    "id": null,
    "metadata": {},
    "name": "PaymentCorpoCardSetupMutation",
    "operationKind": "mutation",
    "text": "mutation PaymentCorpoCardSetupMutation(\n  $corpoRef: String!\n) {\n  payment {\n    corpo {\n      res: createCardSetupIntent(corpoRef: $corpoRef) {\n        code\n        message\n        data\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '323714dd9fab44c552cc2f76aab74a02';

module.exports = node;
